import type { ISpread } from "../../spreadsSlice";

export const yearlySpread: ISpread = {
  id: "spread_yearly",
  name: "Годовой расклад",
  altNames: ["Year Spread", "Год вперёд"],
  purpose:
    "Дать обзор тенденций каждого из двенадцати последовательных месяцев и выделить общую тему или урок всего года.",
  cardsCount: 13,
  layout: "[1] [2] [3] ... [12]   [13]",
  positions: [
    {
      id: "month_1",
      title: "Месяц 1",
      meaning: "Основная тема первого месяца выбранного периода.",
    },
    {
      id: "month_2",
      title: "Месяц 2",
      meaning: "Основная тема второго месяца выбранного периода.",
    },
    {
      id: "month_3",
      title: "Месяц 3",
      meaning: "Основная тема третьего месяца выбранного периода.",
    },
    {
      id: "month_4",
      title: "Месяц 4",
      meaning: "Основная тема четвёртого месяца выбранного периода.",
    },
    {
      id: "month_5",
      title: "Месяц 5",
      meaning: "Основная тема пятого месяца выбранного периода.",
    },
    {
      id: "month_6",
      title: "Месяц 6",
      meaning: "Основная тема шестого месяца выбранного периода.",
    },
    {
      id: "month_7",
      title: "Месяц 7",
      meaning: "Основная тема седьмого месяца выбранного периода.",
    },
    {
      id: "month_8",
      title: "Месяц 8",
      meaning: "Основная тема восьмого месяца выбранного периода.",
    },
    {
      id: "month_9",
      title: "Месяц 9",
      meaning: "Основная тема девятого месяца выбранного периода.",
    },
    {
      id: "month_10",
      title: "Месяц 10",
      meaning: "Основная тема десятого месяца выбранного периода.",
    },
    {
      id: "month_11",
      title: "Месяц 11",
      meaning: "Основная тема одиннадцатого месяца выбранного периода.",
    },
    {
      id: "month_12",
      title: "Месяц 12",
      meaning: "Основная тема двенадцатого месяца выбранного периода.",
    },
    {
      id: "year_summary",
      title: "Итог года",
      meaning: "Главная тема, общий урок или итоговая энергия периода.",
    },
  ],
  symbolism:
    "Двенадцать последовательных этапов образуют временной цикл, а заключительная карта объединяет их в общую тему года.",
  archetypes: ["Цикл", "Колесо времени", "Сезонность"],
  psychology:
    "Помогает распределить внимание и ресурсы в течение длительного периода и увидеть возможные фазы напряжения, движения и роста.",
  procedure: {
    preparation:
      "Сформулировать намерение получить обзор года и определить начальную точку отсчёта.",
    steps:
      "Перетасовать колоду; выложить двенадцать карт по порядку месяцев, затем тринадцатую карту как общий итог; прочитать отдельные периоды и после этого итоговую тему.",
  },
  interpretations: [
    "Повторяющиеся масти могут показывать доминирующую тему длительного периода.",
    "Старшие арканы в отдельных месяцах могут отмечать особенно значимые этапы.",
  ],
  nuances: [
    "Это CUSTOM-версия годового расклада с дополнительной тринадцатой итоговой картой.",
    "Не трактовать отдельные месяцы как неизбежно фиксированные события.",
    "Итоговая карта является синтезом периода, а не тринадцатым месяцем.",
  ],
  examples: [
    {
      cards: [
        "Туз Жезлов",
        "Мир",
        "6 Мечей",
        "Император",
        "9 Кубков",
        "Башня",
        "Отшельник",
        "Сила",
        "3 Пентаклей",
        "Солнце",
        "5 Жезлов",
        "Колесница",
        "Звезда",
      ],
      interpretation:
        "Год активных начинаний, переходов и завершений; середина периода связана с кризисом и внутренней работой, а итоговая тема — надежда и обновление.",
    },
  ],
  selfQuestions: [
    "Какие периоды потребуют особого внимания?",
    "Какие темы повторяются на протяжении года?",
    "Как общий урок года соотносится с моими целями?",
  ],
};

